import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.CONFIGS,
    method: "get",
    params,
  });
}

async function fetchById(id) {
  return await request({
    url: `${ENDPOINT.CONFIGS}/${id}`,
    method: "get",
  });
}

function create(data) {
  return request({
    url: ENDPOINT.CONFIGS,
    method: "post",
    data,
  });
}

function update(data) {
  return request({
    url: `${ENDPOINT.CONFIGS}/${data.id}`,
    method: "patch",
    data,
  });
}

function remove(data) {
  return request({
    url: `${ENDPOINT.CONFIGS}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  fetchById,
  create,
  update,
  remove,
};
